// app modules: components
import { AuthorsMatrix, BooksMatrix, ContentsMatrix } from 'components/Matrix';

export default {
  contents: {
    heading: 'Recipes',
    component: ContentsMatrix,
    itemWidth: 230,
  },
  books: {
    heading: 'Books',
    component: BooksMatrix,
    itemWidth: 320,
  },
  people: {
    heading: 'Authors',
    component: AuthorsMatrix,
    itemWidth: 230,
  },
};
